// extracted by mini-css-extract-plugin
export default {"refreshStyle":"UnitStatsTable_refreshStyle__1Ei8U","spinRefresh":"UnitStatsTable_spinRefresh__9TVgq","refreshStyleLoading":"UnitStatsTable_refreshStyleLoading__UXGc9"};